// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plan-name[data-v-6ba1791b]{font-size:20px;margin-bottom:20px;text-align:center}.confirm-unsubscribe-member-plan[data-v-6ba1791b]{padding-top:20px;padding-bottom:20px}", ""]);
// Exports
module.exports = exports;
